import {EventEmitter, Injectable} from '@angular/core';
import {MDBSpinningPreloader} from 'ng-uikit-pro-standard';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  onLoadingChanged = new EventEmitter<boolean>();

  constructor(private mdbSpinningPreloader: MDBSpinningPreloader) {}

  show() {

    this.mdbSpinningPreloader.start();
    this.onLoadingChanged.emit(true);
  }

  hide() {

    this.mdbSpinningPreloader.stop();
    this.onLoadingChanged.emit(false);
  }

}
